module.exports = __webpack_public_path__ + "static/media/recs-video-bg.7b053bb4.jpg";